import dayjs from 'dayjs';
import { array, object, string } from 'yup';

import { ICaptureFactFindExpenditureRequest, IExpense } from '@zeta-types';

export const expenditureValidations = object().shape({
  detail: string(),
  category: string().nullable(),
  vendorName: string(),
  amount: string().nullable(),
  frequency: string(),
  paymentMethod: string(),
  dueDate: string(),
});

export const expenditureValidationSchema = object().shape({
  client: array().of(expenditureValidations),
  partner: array().of(expenditureValidations),
  joint: array().of(expenditureValidations),
});

export const expenditureDefault = (ffConfig) => [
  {
    detail: 'Mortgage',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.mortgage?.active ?? true,
  },
  {
    detail: 'Rent',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.rent?.active ?? true,
  },
  {
    detail: 'Council Tax',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.councilTax?.active ?? true,
  },
  {
    detail: 'Electricity',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.electricity?.active ?? true,
  },
  {
    detail: 'Gas',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.gas?.active ?? true,
  },
  {
    detail: 'Water',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.water?.active ?? true,
  },
  {
    detail: 'TV/Phone/Broadband',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.phoneTvBroadband?.active ?? true,
  },
  {
    detail: 'Insurance Premiums',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.insurancePremiums?.active ?? true,
  },
  {
    detail: 'Child School Fees',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.childrenSchoolFees?.active ?? true,
  },
  {
    detail: 'Household Maintenance',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.householdMaintenance?.active ?? true,
  },
  {
    detail: 'Food',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.food?.active ?? true,
  },
  {
    detail: 'Clothes',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.clothes?.active ?? true,
  },
  {
    detail: 'Car Insurance',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.carInsurance?.active ?? true,
  },
  {
    detail: 'Fuel & Maintenance',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.carFuelAndMaintenance?.active ?? true,
  },
  {
    detail: 'Holidays',
    category: '',
    vendorName: '',
    amount: 0,
    frequency: '',
    paymentMethod: '',
    dueDate: '',
    show: ffConfig?.travelHolidayTrips?.active ?? true,
  },
];

export const expenditureDefaultValues = (ffConfig) => {
  return {
    client: expenditureDefault(ffConfig),
    partner: expenditureDefault(ffConfig),
    joint: expenditureDefault(ffConfig),
  };
};

export const createExpenditurePayload = (values: any): ICaptureFactFindExpenditureRequest => {
  const mapExpenditure = (expenditureList: any): IExpense => {
    const result: any = expenditureList.map((item: any) => {
      return {
        id: item.id || '',
        expenditureType: item.detail || '',
        amount: item.amount || 0,
        currency: 'GBP',
        expenditureCategory: item.category || '',
        frequency: item.frequency || '',
        dueDate: dayjs(item.dueDate).isValid() ? dayjs(item.dueDate).format('YYYY-MM-DD') : '',
        paymentMethod: item.paymentMethod || '',
        venderName: item.vendorName || '',
        notes: '',
      };
    });

    return result;
  };

  return {
    clientExpense: mapExpenditure(values.client || []),
    partnerExpense: mapExpenditure(values.partner || []),
    jointExpense: mapExpenditure(values.joint || []),
  };
};
